"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      borderBottom: '1px solid rgba(0,0,0,.1)',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      marginBottom: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    })
  };
}, {
  name: 'CatalogueProductListMultipleFilterContainer'
});

function CatalogueProductListMultipleFilterContainer(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), children);
}

process.env.NODE_ENV !== "production" ? CatalogueProductListMultipleFilterContainer.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
CatalogueProductListMultipleFilterContainer.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined
};
var _default = CatalogueProductListMultipleFilterContainer;
exports.default = _default;